import { render, staticRenderFns } from "./ProductImportDialog.vue?vue&type=template&id=0884bde2&scoped=true"
import script from "./ProductImportDialog.vue?vue&type=script&lang=js"
export * from "./ProductImportDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductImportDialog.vue?vue&type=style&index=0&id=0884bde2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884bde2",
  null
  
)

export default component.exports